// Footer.jsx

import React from 'react';

const Footer = () => {
    return (
        <footer className="mt-auto bg-neutral-50 px-4 py-5 text-center">
            <div className="pt-8">
                <p className="m-0 text-sm text-neutral-500">&copy; 2024 HMR Decor. All Rights Reserved.</p>
                <a className="text-[8px] text-neutral-500" href="https://www.flaticon.com/free-icons/instagram-logo" title="instagram logo icons">Instagram logo icons created by Freepik - Flaticon</a>
            </div>
        </footer>
    );
}

export default Footer;
